module.exports = __webpack_public_path__ + "img/cloud_rain.94a73d2b.gif";